'use client';

import { ShowcaseIcon } from '../../collection-showcase/scenes/scene-primitives.jsx';
import { BlurSwap } from '../../collection-showcase/scenes/playback-controls.jsx';
import { CompletionMark } from '../../collection-showcase/scenes/playback-controls.jsx';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import {
  ShowcaseCopyContext,
  translateShowcaseNode,
} from '../../collection-showcase/translation';
import {
  useBusinessPlayback,
  typedText,
  BusinessComposer,
} from './business-primitives';
import {
  pa,
  z,
  sa,
  ca,
  la,
  GrowingMessage,
  SchedulePrompt,
  ua,
  da,
  ScheduleCard,
  DateDivider,
  fa,
  ScheduleResult,
} from './finance-animation';
import { Se } from './business-facts';
export function WorkStatus({ done: e, label: t }) {
  return (
    <div className={'text-ink-3 flex h-7 items-center gap-2 px-1 text-[14px]'}>
      <CompletionMark done={e} className={'size-4 shrink-0'} />
      <BlurSwap className={'num'} value={t} />
      <ShowcaseIcon name={'chevronDown'} className={'size-4 shrink-0'} />
    </div>
  );
}
export function ScheduleAnimation({ running: e, onDone: t }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let { t: n } = useBusinessPlayback(pa, {
      running: e,
      onDone: t,
    }),
    r =
      n >= z.type + 240 && n < z.send
        ? `${sa}${typedText(ca, n, z.type + 240, la)}`
        : '',
    i = n >= z.report,
    a = [
      {
        date: 'Oct 12',
        state: i ? 'done' : n >= z.running ? 'running' : 'scheduled',
      },
      ...(i
        ? [
            {
              date: 'Oct 19',
              state: 'scheduled',
            },
          ]
        : []),
    ];
  return (
    <div className={'p-2 md:p-4'}>
      <div
        className={
          'flex h-[620px] flex-col overflow-hidden rounded-[10px] bg-[var(--background)] shadow-[var(--sh-1)] md:h-[640px]'
        }
      >
        <div
          role={'log'}
          aria-label={translateShowcaseNode(showcaseCopy, 'Chat with IMAI')}
          className={
            'flex min-h-0 flex-1 flex-col justify-end overflow-hidden [mask-image:linear-gradient(to_bottom,transparent_0,#000_72px)] px-3 sm:px-6'
          }
        >
          <div className={'mx-auto w-full max-w-[680px] pb-3'}>
            {translateShowcaseNode(
              showcaseCopy,
              n >= z.send ? (
                <GrowingMessage>
                  <div className={'bz-sent'}>
                    <div>
                      <SchedulePrompt />
                    </div>
                  </div>
                </GrowingMessage>
              ) : null
            )}
            {translateShowcaseNode(
              showcaseCopy,
              n >= z.send + 200 ? (
                <GrowingMessage>
                  <WorkStatus
                    done={n >= z.worked}
                    label={
                      n >= z.worked
                        ? 'Worked for 9s'
                        : 'Setting up the schedule'
                    }
                  />
                </GrowingMessage>
              ) : null
            )}
            {translateShowcaseNode(
              showcaseCopy,
              n >= z.reply ? (
                <GrowingMessage>
                  <p className={'text-ink px-1 text-[15px] leading-6'}>
                    {translateShowcaseNode(
                      showcaseCopy,
                      'Done. I\u2019ll update the forecast every Monday at 8:00 AM and tell you here if the low week moves. Right now it\u2019s week'
                    )}
                    {translateShowcaseNode(showcaseCopy, ' ')}
                    {translateShowcaseNode(showcaseCopy, ua.week)}
                    {translateShowcaseNode(showcaseCopy, ' at ')}
                    {translateShowcaseNode(showcaseCopy, da(ua.base))}
                    {translateShowcaseNode(showcaseCopy, '.')}
                  </p>
                </GrowingMessage>
              ) : null
            )}
            {translateShowcaseNode(
              showcaseCopy,
              n >= z.card ? (
                <GrowingMessage>
                  <ScheduleCard
                    nextRun={i ? 'Mon, Oct 19' : 'Mon, Oct 12'}
                    runs={a}
                  />
                </GrowingMessage>
              ) : null
            )}
            {translateShowcaseNode(
              showcaseCopy,
              n >= z.jump ? (
                <GrowingMessage>
                  <DateDivider label={'Mon, Oct 12 \xB7 8:00 AM'} />
                </GrowingMessage>
              ) : null
            )}
            {translateShowcaseNode(
              showcaseCopy,
              n >= z.running ? (
                <GrowingMessage>
                  <WorkStatus
                    done={i}
                    label={
                      i
                        ? 'Scheduled run \xB7 worked for 1m 12s'
                        : 'Monday cash check is running'
                    }
                  />
                </GrowingMessage>
              ) : null
            )}
            {translateShowcaseNode(
              showcaseCopy,
              i ? (
                <GrowingMessage>
                  <p className={'text-ink px-1 text-[15px] leading-6'}>
                    {translateShowcaseNode(
                      showcaseCopy,
                      'This week\u2019s low is still week '
                    )}
                    {translateShowcaseNode(showcaseCopy, ua.week)}
                    {translateShowcaseNode(showcaseCopy, ' at ')}
                    {translateShowcaseNode(showcaseCopy, da(ua.base))}
                    {translateShowcaseNode(
                      showcaseCopy,
                      '. The wholesale deposit landed, so the downside improved to'
                    )}
                    {translateShowcaseNode(showcaseCopy, ' ')}
                    {translateShowcaseNode(showcaseCopy, da(fa))}
                    {translateShowcaseNode(showcaseCopy, '.')}
                    {translateShowcaseNode(showcaseCopy, ' ')}
                    <span className={'text-ink-4 text-[13px]'}>
                      {translateShowcaseNode(showcaseCopy, 'Illustrative.')}
                    </span>
                  </p>
                </GrowingMessage>
              ) : null
            )}
            {translateShowcaseNode(
              showcaseCopy,
              n >= z.chip ? (
                <GrowingMessage>
                  <ScheduleResult done={!0} />
                </GrowingMessage>
              ) : null
            )}
          </div>
        </div>
        <div className={'shrink-0 px-3 pt-1 pb-3 sm:px-6 sm:pb-4'}>
          <div className={'mx-auto max-w-[680px]'}>
            <BusinessComposer
              placeholder={n >= z.send ? 'Send a follow up' : 'Ask anything'}
              text={r}
              typing={r.length > 0}
              pressed={n >= z.send - 160 && n < z.send}
              token={sa}
            />
            <div
              className={
                'mt-2 flex [scrollbar-width:none] gap-1.5 overflow-x-auto px-0.5'
              }
            >
              {translateShowcaseNode(
                showcaseCopy,
                Se.schedule.examples.map((e) => (
                  <span
                    key={e}
                    className={
                      'text-ink-3 flex h-8 shrink-0 items-center gap-1.5 rounded-full bg-[var(--tint)] px-3 text-[13px]'
                    }
                  >
                    <ShowcaseIcon name={'clock'} className={'size-3.5'} />
                    {translateShowcaseNode(showcaseCopy, e)}
                  </span>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export function ApprovalToggle({ on: e, label: t, disabled: n, onToggle: r }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <button
      type={'button'}
      role={'switch'}
      aria-checked={e}
      aria-label={translateShowcaseNode(showcaseCopy, t)}
      disabled={n}
      onClick={r}
      className={
        'relative grid h-10 w-11 shrink-0 place-items-center disabled:opacity-60'
      }
    >
      <span
        className={`flex h-[18px] w-8 items-center rounded-full p-0.5 transition-colors duration-200 ${e ? 'bg-[var(--primary)]' : 'bg-[var(--state-wash)] shadow-[inset_0_0_0_1px_var(--border)]'}`}
      >
        <span
          className={
            'size-3.5 rounded-full bg-[var(--background)] shadow-[0_1px_2px_rgb(0_0_0/0.2)] transition-transform duration-200 ease-[var(--ease)]'
          }
          style={{
            transform: e ? 'translateX(14px)' : 'none',
          }}
        />
      </span>
    </button>
  );
}
